import { createRouter, createWebHistory } from "vue-router";


let routes = [];

routes = [
  {
    path: "/:slug",
    name: "ProductHistory",
    component: () => import("../views/ProductHistory.vue"),
    props: true,
  },
  {
    path: "/:catchAll(.*)",
    name: "NotFound",
    redirect: "/not-found",
  },
];

const router = createRouter({
  history: createWebHistory("/product-history"),
  routes,
});


router.onError(error => {
  if (
    router.pending?.fullPath &&
    (error?.name === "ChunkLoadError" ||
      (error?.name === "TypeError" && error?.message?.includes("dynamically imported module")) ||
      (error?.name === "Error" && error?.message?.includes("Unable to preload CSS")))
  ) {
    // try to reload the desired view
    window.location.assign(router.pending.fullPath);
  } else {
    // else, just reload
    window.location.reload();
  }
});

export default router;
